import styled from 'styled-components';

import { ButtonStyled } from '../../../../components/Button/Button.styled';

export const TransportationFormWrapperStyled = styled.div`
  margin-top: 20px;
`;

export const TransportsWrapperStyled = styled.div`
  position: relative;
  display: flex;

  align-items: center;

  flex-wrap: wrap;
  gap: 10px;
`;

export const ToggleWrapperStyled = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  margin-left: 20px;
`;

export const SegmentRowStyled = styled.div`
  display: flex;
  flex-direction: column;

  & + & {
    margin-top: 30px;
    gap: 20px;
  }
`;

export const LabelStyled = styled.p`
  margin-bottom: 10px;
  text-transform: capitalize;
`;

export const DestinationWrapperStyled = styled.div`
  display: flex;
  align-items: flex-end;
  flex: 1;
  gap: 15px;

  ${({ theme }) => `
    ${theme.devices.touch} {
      width: 100%;
    }
  `}

  .react-select__value-container {
    padding-left: 10px;
  }
`;

export const ColStyled = styled.div`
  width: 50%;

  ${({ theme }) => `
    ${theme.devices.mobile} {
      width: 100%;
    }
  `}
`;

export const WarningStyled = styled.p`
  position: absolute;
  bottom: -20px;
  margin: 0;
  color: #dc3545;
`;

export const OffsetButtonWrapperStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 50px;
  width: 50%;

  ${({ theme }) => `
    ${theme.devices.touch} {
      width: 100%;
    }    
  `}
`;

export const FormRowStyled = styled.div`
  display: flex;
  gap: 10px;

  ${({ theme }) => `
    ${theme.devices.mobile} {
      flex-direction: column;
    }
  `}
`;

export const ControlsWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;

  ${ButtonStyled} {
    flex: none;
  }
`;

export const RowsWrapperStyled = styled.div`
  width: 50%;

  ${({ theme }) => `
    ${theme.devices.touch} {
      width: 100%;
    }
  `};
`;

export const NoOptionsWrapperStyled = styled.div`
  text-align: left;
`;
